<template>

    <nav id="sidebarMenu" class="sidebar show collapse">
        <div class="position-sticky pt-3">
            <ul class="nav flex-column parent-menu">
                <li class="nav-item">
                    <router-link :to="{ name: 'home' }" @click.native="getSoundClick" :class="menu_active == 'home'?'nav-link active':'nav-link'">
                        <i class="lisa-icon-menu-home"></i>
                        <p>{{ $t('menu_item_home') }}</p>
                    </router-link>
                </li>
                <li class="nav-item" v-if="(child_account && child_account.student_type==1)">
                    <router-link :to="{ name: 'grade_book' }" @click.native="getSoundClick" :class="menu_active == 'grade_book'?'nav-link active':'nav-link'">
                        <i class="lisa-icon-menu-gradebook"></i>
                        <p>{{ $t('gradebook') }}</p>
                    </router-link>
                </li>
                <li class="nav-item" v-if="(child_account && child_account.student_type==1)">
                    <router-link :to="{ name: 'parent_feedback' }" @click.native="getSoundClick" :class="menu_active == 'parent_feedback'?'nav-link active':'nav-link'">
                        <i class="lisa-icon-menu-feedback"></i>
                        <p>{{ $t('feedback') }}</p>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'parent_profile' }" @click.native="getSoundClick" :class="menu_active == 'parent_profile'?'nav-link active':'nav-link'">
                        <i class="lisa-icon-menu-profile"></i>
                        <p>{{ $t('profile') }}</p>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'parent_report' }" @click.native="getSoundClick" :class="menu_active == 'parent'?'nav-link active':'nav-link'">
                        <i class="lisa-icon-menu-report"></i>
                        <p>{{ $t('reports') }}</p>
                    </router-link>
                </li>
            </ul>
        </div>
    </nav>
    
</template>

<script>
    import axios from 'axios'
    import {mapGetters} from 'vuex'
    import {getMenus} from '../models/menu'
    import $ from 'jquery'
    import {soundClick} from '../utils/utils'

    export default {
        name: "SideBarParent",

        data() {
            let child_account = localStorage.getItem('child_account');

            child_account = child_account?JSON.parse(child_account):null;

            if(child_account == null && this.$store.state.user_info.childrens){
                child_account = this.$store.state.user_info.childrens[0];
            }

            return {
                menus: [],
                is_free_trial: false,
                child_account: child_account,
            };
        },

        computed: {
            user_info() {
                return this.$store.state.user_info
            },
            menu_active() {
                return this.$store.state.menu_active
            }
        },

        created() {
            if(!localStorage.getItem('child_account')){
                if (this.$store.state.user_info.childrens) {
                    if(this.$store.state.user_info.childrens.length > 0){
                        localStorage.setItem('child_account', JSON.stringify(this.$store.state.user_info.childrens[0]));
                    }
                }else{
                    // localStorage.setItem('child_account', JSON.stringify({}));
                }

            }
            this.fetch();
        },

        updated: function () {
            this.$nextTick(function () {
                //App.init();
            })
        },

        methods: {
            fetch() {
                if(this.user_info.account_type  == 1){
                    this.is_free_trial = true
                }else{
                    this.is_free_trial = false
                }
            },

            getSoundClick() {
                soundClick();
            },

            onLogout(e) {
                this.$store.dispatch('logout').then(() => {
                    window.location.href = "/login";
                });

                e.preventDefault();
            },
        }
    }
</script>

<style scoped>

</style>
